import { render, staticRenderFns } from "./BuyerSpaceAffichage.vue?vue&type=template&id=2f3a939a&"
import script from "./BuyerSpaceAffichage.vue?vue&type=script&lang=js&"
export * from "./BuyerSpaceAffichage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports